import React, { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { api } from '../services/homphyApi';
import { useNavigate } from 'react-router-dom';

type NotificationItem = {
  id: number;
  type: string;
  title: string;
  body: string;
  link?: string;
  read: boolean;
  createdAt: string;
};

export default function NotificationsBell() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<NotificationItem[]>([]);
  const [unread, setUnread] = useState(0);

  const load = async () => {
    const result = await api.get<{ content: NotificationItem[]; unreadCount: number }>('/notifications/me?size=20');
    setItems(result.content);
    setUnread(result.unreadCount);
  };

  useEffect(() => {
    void load();
    const interval = window.setInterval(() => void load(), 60_000);
    return () => window.clearInterval(interval);
  }, []);

  const openNotification = async (item: NotificationItem) => {
    if (!item.read) {
      await api.patch(`/notifications/${item.id}/read`);
      setItems(current => current.map(entry => entry.id === item.id ? { ...entry, read: true } : entry));
      setUnread(current => Math.max(0, current - 1));
    }
    setOpen(false);
    if (item.link) navigate(item.link);
  };

  return (
    <div className="relative">
      <button onClick={() => setOpen(value => !value)} className="relative p-2 text-slate-500 hover:text-brand-700" aria-label="Notifications">
        <Bell className="w-5 h-5" />
        {unread > 0 && <span className="absolute -right-0.5 -top-0.5 min-w-4 h-4 rounded-full bg-red-500 px-1 text-[9px] font-black text-white">{unread > 9 ? '9+' : unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 top-11 z-[70] w-80 max-w-[calc(100vw-2rem)] rounded-2xl border border-slate-200 bg-white p-2 shadow-xl">
          <div className="px-3 py-2 text-xs font-black uppercase tracking-widest text-slate-500">Notifications</div>
          {items.length === 0 ? <p className="px-3 py-5 text-sm text-slate-400">No notifications yet.</p> : items.map(item => (
            <button key={item.id} onClick={() => void openNotification(item)} className={`block w-full rounded-xl px-3 py-3 text-left hover:bg-slate-50 ${item.read ? '' : 'bg-brand-50/60'}`}>
              <div className="flex items-start justify-between gap-2"><strong className="text-sm text-slate-900">{item.title}</strong><span className="text-[10px] text-slate-400">{new Date(item.createdAt).toLocaleDateString()}</span></div>
              <p className="mt-1 text-xs text-slate-600">{item.body}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
